module.exports = __webpack_public_path__ + "static/customize-phone-2-e6cf0d3f78fb23a5870e09ecc75e377c.png";